interface IUserAgentData {
  mobile?: boolean;
}

export function isMobileDevice(): boolean {
  if (typeof navigator === 'undefined') {
    return false;
  }
  const uaData = (navigator as Navigator & { userAgentData?: IUserAgentData }).userAgentData;
  if (uaData && typeof uaData.mobile === 'boolean') {
    return uaData.mobile;
  }
  return /Android|iPhone|iPad|iPod|Mobile|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent,
  );
}
